export class networkOperatorList {
  networkOperatorData = [
    { id: 1, value: '50Hertz Transmission GmbH' },
    { id: 2, value: 'Abita Energie Otterberg GmbH' },
    { id: 3, value: 'Albstadtwerke GmbH' },
    { id: 4, value: 'Albwerk GmbH & Co. KG' },
    { id: 5, value: 'AllgäuNetz GmbH & Co. KG' },
    { id: 6, value: 'Alliander Netz Heinsberg GmbH' },
    { id: 7, value: 'Amprion GmbH' },
    { id: 8, value: 'ASCANETZ GmbH' },
    { id: 9, value: 'Aschaffenburger Versorgungs-GmbH' },
    { id: 10, value: 'Avacon Netz GmbH' },
    { id: 11, value: 'Avacon Hochdrucknetz GmbH' },
    { id: 12, value: 'AVU Netz GmbH' },
    { id: 13, value: 'Bad Honnef AG' },
    { id: 14, value: 'BASF Schwarzheide GmbH' },
    { id: 15, value: 'Bauer Netz GmbH & Co. KG' },
    { id: 16, value: 'Bayerische Rhöngas GmbH' },
    { id: 17, value: 'bayernets GmbH' },
    { id: 18, value: 'Bayernwerk Netz GmbH' },
    { id: 19, value: 'BeSte Stadtwerke GmbH' },
    { id: 20, value: 'BEW Bergische Energie- und Wasser-GmbH' },
    { id: 21, value: 'BEW Netze GmbH' },
    { id: 22, value: 'BIGGE ENERGIE GmbH & Co. KG' },
    { id: 23, value: 'Blomberger Versorgungsbetriebe GmbH' },
    { id: 24, value: 'bnNETZE GmbH' },
    { id: 25, value: 'Bocholter Energie- und Wasserversorgung GmbH' },
    { id: 26, value: 'Bonn-Netz GmbH' },
    { id: 27, value: 'Braunschweiger Netz GmbH' },
    { id: 28, value: 'Brücken-Center Ansbach GmbH' },
    { id: 29, value: 'BSS Netz- und Service Betriebs GmbH' },
    { id: 30, value: 'BTT Bauteam Tretzel GmbH' },
    { id: 31, value: 'Butzbacher Netzbetrieb GmbH & Co. KG' },
    { id: 32, value: 'C. Ensinger GmbH & Co. KG' },
    { id: 33, value: 'Celle-Uelzen Netz GmbH' },
    { id: 34, value: 'Covestro Brunsbüttel Energie GmbH' },
    { id: 35, value: 'Cramer - Mühle KG' },
    { id: 36, value: 'Creos Deutschland GmbH' },
    { id: 37, value: 'Currenta GmbH & Co. OHG' },
    { id: 38, value: 'DB Energie GmbH (Verteilernetz 50 Hz)' },
    { id: 39, value: 'Dessauer Stromversorgung GmbH' },
    { id: 40, value: 'Donau-Stadtwerke Dillingen-Lauingen' },
    { id: 41, value: 'Dortmunder Netz GmbH' },
    { id: 42, value: 'Dow Olefinverbund GmbH' },
    { id: 43, value: 'SachsenNetze GmbH' },
    { id: 44, value: 'E.DIS Netz GmbH' },
    { id: 45, value: 'e.wa riss Netze GmbH' },
    { id: 46, value: 'ED Netze GmbH' },
    { id: 47, value: 'EEV Energie-Ems- Vechte GmbH & Co. KG' },
    { id: 48, value: 'EGC Energie- und Gebäudetechnik Control GmbH & Co. KG' },
    { id: 49, value: 'EGF EnergieGesellschaft Frankenberg mbH' },
    { id: 50, value: 'EGT Energie GmbH' },
    { id: 51, value: 'EHINGER ENERGIE GmbH & Co. KG' },
    {
      id: 52,
      value: 'Eichenmüller GmbH & Co. KG Energieversorgung+Elektrotechnik'
    },
    {
      id: 53,
      value: 'Eichsfelder Energie- und Wasserversorgungsgesellschaft mbH'
    },
    { id: 54, value: 'ELE Verteilnetz GmbH' },
    { id: 55, value: 'Elektra - Genossenschaft Pinzberg eG' },
    { id: 56, value: 'Elektra-Genossenschaft Effeltrich eG' },
    {
      id: 57,
      value: 'Elektrizitäts- und Wasserversorgungsgenossenschaft Vagen eG'
    },
    { id: 58, value: 'Elektrizitätsgenossenschaft Dirmstein eG' },
    { id: 59, value: 'Elektrizitätsgenossenschaft Engelsberg eG' },
    { id: 60, value: 'Elektrizitätsgenossenschaft e.G. Hasbergen' },
    { id: 61, value: 'Elektrizitätsgenossenschaft Karlstein eG' },
    {
      id: 62,
      value: 'Elektrizitätsgenossenschaft Nordhalben und Umgebung e. G.'
    },
    { id: 63, value: 'Elektrizitätsgenossenschaft Oesterweg eG' },
    { id: 64, value: 'Elektrizitätsgenossenschaft Ohlstadt eG' },
    { id: 65, value: 'Elektrizitäts-Genossenschaft Rettenberg eG' },
    { id: 66, value: 'Elektrizitäts-Genossenschaft Röthenbach eG' },
    { id: 67, value: 'Elektrizitätsgenossenschaft Schlachters e.G.' },
    { id: 68, value: 'Elektrizitäts-Genossenschaft Schonstett eG' },
    { id: 69, value: 'Elektrizitäts-Genossenschaft Tacherting-Feichten eG' },
    { id: 70, value: 'Elektrizitätsgenossenschaft Unterneukirchen eG' },
    { id: 71, value: 'Elektrizitätsgenossenschaft Vogling & Angrenzer eG' },
    {
      id: 72,
      value: 'Elektrizitätsgenossenschaft Wolkersdorf und Umgebung eG'
    },
    { id: 73, value: 'Elektrizitätsnetze Allgäu GmbH' },
    { id: 74, value: 'Elektrizitätsvereinigung Böbing eG' },
    { id: 75, value: 'Elektrizitäts-Versorgungs-Genossenschaft Perlesreut eG' },
    { id: 76, value: 'Elektrizitätswerk Bruchmühlbach-Miesau' },
    { id: 77, value: 'Elektrizitätswerk Dahner Felsenland' },
    { id: 78, value: 'Elektrizitätswerk des Kantons Schaffhausen AG' },
    { id: 79, value: 'Elektrizitätswerk Dießen Stadler GmbH' },
    { id: 80, value: 'Elektrizitätswerk Georg Grandl e.K.' },
    { id: 81, value: 'Elektrizitätswerk Goldbach-Hösbach GmbH & Co. KG' },
    { id: 82, value: 'Elektrizitätswerk Heinrich Schirmer GmbH' },
    { id: 83, value: 'Elektrizitätswerk Hindelang eG' },
    { id: 84, value: 'Karl Stengle GmbH & Co. KG' },
    { id: 85, value: 'Elektrizitätswerk Leitlein GmbH & Co. KG' },
    { id: 86, value: 'Elektrizitätswerk Mainbernheim GmbH' },
    { id: 87, value: 'TauberEnergie Kuhn, Karl und Andreas Kuhn OHG' },
    { id: 88, value: 'Elektrizitätswerk Max Peissker' },
    { id: 89, value: 'Elektrizitätswerk Oberwössen e.G.' },
    { id: 90, value: 'Elektrizitätswerk Ottenhöfen Moser GmbH & Co. KG' },
    { id: 91, value: 'Elektrizitäts-Werk Ottersberg' },
    { id: 92, value: 'Elektrizitätswerk Rohmund GmbH' },
    { id: 93, value: 'Heinrich N. Clausen GmbH & Co. KG' },
    { id: 94, value: 'Elektrizitätswerk Simbach GmbH' },
    { id: 95, value: 'Elektrizitätswerk Stern KG Bad Endorf' },
    { id: 96, value: 'Elektrizitätswerk Tegernsee Carl Miller KG' },
    {
      id: 97,
      value: 'Elektrizitätswerk Unterwössen Döllerer&Greimel Netz GmbH&Co.KG'
    },
    { id: 98, value: 'Elektrizitätswerk Wanfried von Scharfenberg KG' },
    { id: 99, value: 'Elektrizitätswerk Wennenmühle Schörger KG' },
    {
      id: 100,
      value: 'Elektrizitätswerk Wörth a. d. Donau Rupert Heider & Co. KG'
    },
    { id: 101, value: 'Elektrizitätswerke Reutte GmbH & Co. KG' },
    { id: 102, value: 'Elektrizitätswerke Schönau Netze GmbH' },
    { id: 103, value: 'Elektroenergieversorgung Cottbus GmbH' },
    {
      id: 104,
      value: 'EMB Energieversorgung Miltenberg- Bürgstadt GmbH & Co. KG'
    },
    { id: 105, value: 'EMIS ENERGY GmbH' },
    { id: 106, value: 'ENA Energienetze Apolda GmbH' },
    { id: 107, value: 'Mainfrankenpark GmbH' },
    { id: 108, value: 'enercity Netz GmbH' },
    { id: 109, value: 'eneREGIO GmbH' },
    { id: 110, value: 'Energie Calw GmbH' },
    { id: 111, value: 'Energie und Versorgung Butzbach GmbH' },
    { id: 112, value: 'Energie- und Wasserversorgung Altenburg GmbH' },
    { id: 113, value: 'Energie- und Wasserversorgung Bruchsal GmbH' },
    { id: 114, value: 'Energie- und Wasserversorgung Bünde GmbH' },
    { id: 115, value: 'Energie- und Wasserversorgung Hamm GmbH' },
    { id: 116, value: 'Energie- und Wasserversorgung Kirchzarten GmbH' },
    { id: 117, value: 'Energie- und Wasserversorgung Rheine GmbH' },
    {
      id: 118,
      value: 'Energie- und Wasserwerke Bautzen GmbH Energijowe a Wodowezawody Budysin'
    },
    { id: 119, value: 'Energie Waldeck-Frankenberg GmbH' },
    { id: 120, value: 'Energiegenossenschaft für Wittmund eG' },
    { id: 121, value: 'EAM Netz (ehem. EnergieNetz Mitte) GmbH' },
    { id: 122, value: 'EAM Netz GmbH' },
    { id: 123, value: 'Energienetze Bayern GmbH (Stromverteilnetz Germering)' },
    { id: 124, value: 'Energienetze Bayern GmbH' },
    { id: 125, value: 'Energienetze Bayern GmbH & Co. KG' },
    { id: 126, value: 'Energienetze Berlin GmbH' },
    { id: 127, value: 'Energienetze Mittelrhein GmbH & Co. KG' },
    { id: 128, value: 'Energienetze Offenbach GmbH' },
    { id: 129, value: 'Energienetze Schaafheim GmbH' },
    { id: 130, value: 'Energiequelle GmbH & Co. Windpark Feldheim 2006 KG' },
    { id: 131, value: 'ENERGIERIED GmbH & Co. KG' },
    { id: 132, value: 'EnergieSüdwest Netz GmbH' },
    { id: 133, value: 'Energieverbund Gierstädt GmbH' },
    { id: 134, value: 'Energieversorgung A9 Mitte GmbH & Co. KG' },
    { id: 135, value: 'Energieversorgung Alzenau GmbH' },
    { id: 136, value: 'Energieversorgung Beckum GmbH & Co. KG' },
    { id: 137, value: 'Energieversorgung Buching-Trauchgau (EBT) GmbH' },
    { id: 138, value: 'Energieversorgung Dahlenburg-Bleckede AG' },
    { id: 139, value: 'Energieversorgung Ergolding-Essenbach GmbH' },
    { id: 140, value: 'Energieversorgung Filstal GmbH & Co. KG' },
    { id: 141, value: 'EVG Energieversorgung Gemünden GmbH' },
    { id: 142, value: 'Energieversorgung Guben GmbH' },
    { id: 143, value: 'Energieversorgung Halle Netz GmbH' },
    { id: 144, value: 'Energieversorgung Inselsberg GmbH' },
    { id: 145, value: 'Energieversorgung Josef Schmid' },
    { id: 146, value: 'Energieversorgung Klettgau-Rheintal GmbH & Co. KG' },
    { id: 147, value: 'Energieversorgung Limburg GmbH' },
    {
      id: 148,
      value: 'Energieversorgung Lohr-Karlstadt und Umgebung GmbH & Co. KG'
    },
    { id: 149, value: 'Energieversorgung Marienberg GmbH' },
    { id: 150, value: 'Stadtwerke Pirna Energie GmbH' },
    { id: 151, value: 'Energieversorgung Putzbrunn GmbH & Co. KG' },
    { id: 152, value: 'Energieversorgung Rottenburg am Neckar GmbH' },
    { id: 153, value: 'Energieversorgung Rüsselsheim GmbH' },
    { id: 154, value: 'Energieversorgung Schwarze Elster GmbH' },
    { id: 155, value: 'Energieversorgung Selb-Marktredwitz GmbH' },
    { id: 156, value: 'Energieversorgung Südbaar GmbH & Co. KG' },
    { id: 157, value: 'Energieversorgung Sylt GmbH' },
    { id: 158, value: 'Energieversorgung Titisee-Neustadt GmbH' },
    { id: 159, value: 'Energieversorgung Trossingen GmbH' },
    { id: 160, value: 'Energiewerke Zeulenroda GmbH' },
    { id: 161, value: 'energis-Netzgesellschaft mbH' },
    { id: 162, value: 'ENERVIE Vernetzt GmbH' },
    { id: 163, value: 'e-netz Südhessen AG' },
    { id: 164, value: 'ENGIE Deutschland GmbH' },
    { id: 165, value: 'ENNI Energie & Umwelt Niederrhein GmbH' },
    { id: 166, value: 'EnR Energienetze Rudolstadt GmbH' },
    { id: 167, value: 'ENRO Ludwigsfelde Netz GmbH' },
    { id: 168, value: 'ENRW Energieversorgung Rottweil GmbH & Co. KG' },
    { id: 169, value: 'SachsenNetze HS.HD GmbH' },
    { id: 170, value: 'energie- und wassergesellschaft mbh' },
    { id: 171, value: 'ENWG Energienetze Weimar GmbH & Co. KG' },
    { id: 172, value: 'enwor - energie & wasser vor ort GmbH' },
    { id: 173, value: 'Erdgas Burgbernheim GmbH' },
    { id: 174, value: 'Erdgas Kempten-Oberallgäu Netz GmbH' },
    { id: 175, value: 'Erdgas Mittelsachsen GmbH' },
    { id: 176, value: 'Erdgas Uffenheim GmbH & Co. KG' },
    { id: 177, value: 'Erdgas Westenthanner GmbH & Co. KG' },
    { id: 178, value: 'Erdgasversorgung Erding GmbH & Co. KG' },
    { id: 179, value: 'e-regio GmbH & Co. KG' },
    { id: 180, value: 'Erlanger Stadtwerke AG' },
    { id: 181, value: 'ErmstalEnergie Dettingen an der Erms GmbH & Co. KG' },
    { id: 182, value: 'EWR Netz (ehemals e-rp)' },
    { id: 183, value: 'e-shelter power grid GmbH' },
    { id: 184, value: 'ESWE Versorgungs AG' },
    { id: 185, value: 'EUROGATE Technical Services GmbH' },
    { id: 186, value: 'EVB Netze GmbH' },
    { id: 187, value: 'EVE Netz GmbH' },
    { id: 188, value: 'EVI Energieversorgung Hildesheim GmbH & Co. KG' },
    { id: 189, value: 'EVI Energieversorgung Ihmert GmbH & Co. KG' },
    { id: 190, value: 'EVIP GmbH' },
    { id: 191, value: 'Evonik Operations GmbH' },
    { id: 192, value: 'EVU der Gemeinde Gochsheim' },
    { id: 193, value: 'EVU der Ortsgemeinde Rheinzabern' },
    { id: 194, value: 'EVU Langenpreising' },
    { id: 195, value: 'EVU Markt Kipfenberg' },
    { id: 196, value: 'EVU Späth e.K.' },
    { id: 197, value: 'EVU Weilerbach' },
    { id: 198, value: 'EW Eichsfeldgas GmbH' },
    {
      id: 199,
      value: 'ewag kamenz Energie und Wasserversorgung Aktiengesellschaft Kamenz'
    },
    { id: 200, value: 'EWE NETZ GmbH' },
    { id: 201, value: 'e-werk Gerolsheim' },
    { id: 202, value: 'E-Werk Meckenheim/Pfalz' },
    { id: 203, value: 'E-Werk Rohrdorf Josef Haimmerer' },
    { id: 204, value: 'E-Werk Rupert Buchauer' },
    { id: 205, value: 'e-werk Sachsenwald GmbH' },
    { id: 206, value: 'Elektrizitätswerk S c h w e i g e r  o.H.G' },
    { id: 207, value: 'E-Werke Haniel Haimhausen OHG' },
    { id: 208, value: 'EW Geiger GmbH' },
    { id: 209, value: 'EWR GmbH (Remscheid)' },
    { id: 210, value: 'EWR Netz GmbH (Worms)' },
    { id: 211, value: 'EWR Netze GmbH (Lichtenstein-Unterhausen)' },
    { id: 212, value: 'ew-schmid GmbH' },
    { id: 213, value: 'ews - Netz GmbH' },
    { id: 214, value: 'EZV Energie- und Service GmbH & Co. KG Untermain' },
    { id: 215, value: 'Fährhafen Sassnitz GmbH' },
    { id: 216, value: 'FairNetz GmbH' },
    { id: 217, value: 'Ferngas Netzgesellschaft mbH' },
    { id: 218, value: 'Feuchter Gemeindewerke GmbH (FGW)' },
    { id: 219, value: 'FischerStrom KG' },
    { id: 220, value: 'Fischereihafen-Betriebsgesellschaft mbH' },
    { id: 221, value: 'Flughafen Düsseldorf GmbH' },
    { id: 222, value: 'Flughafen Energie & Wasser GmbH' },
    { id: 223, value: 'Flughafen Hannover-Langenhagen GmbH' },
    { id: 224, value: 'Flughafen Köln/Bonn GmbH' },
    { id: 225, value: 'Flughafen München GmbH' },
    { id: 226, value: 'Flughafen Nürnberg Energie GmbH' },
    { id: 227, value: 'Flughafen Stuttgart Energie GmbH' },
    { id: 228, value: 'Fluxys Deutschland GmbH' },
    { id: 229, value: 'Fluxys TENP GmbH' },
    { id: 230, value: 'Fraport AG' },
    { id: 231, value: 'Freiberger Erdgas GmbH' },
    { id: 232, value: 'Freiberger Stromversorgung GmbH' },
    { id: 233, value: 'Freisinger Stadtwerke Versorgungs-GmbH' },
    { id: 234, value: 'Freitaler Stadtwerke GmbH' },
    { id: 235, value: 'Freudenberg Service KG' },
    {
      id: 236,
      value: 'Fürstlich Fugger von Glött´sche Elektrizitätswerk GmbH & Co KG'
    },
    { id: 237, value: 'Gammertinger Energie- und Wasserversorgung GmbH' },
    { id: 238, value: 'Gas und Wärme GmbH Bad Aibling' },
    { id: 239, value: 'Gas- Versorgungsbetriebe Cottbus GmbH' },
    { id: 240, value: 'Gasgesellschaft Kerken-Wachtendonk mbH' },
    { id: 241, value: 'Gastransport Nord GmbH' },
    { id: 242, value: 'Gasunie Deutschland Transport Services GmbH' },
    { id: 243, value: 'Gas-Union Transport GmbH' },
    { id: 244, value: 'Gasversorgung Angermünde GmbH' },
    { id: 245, value: 'Gasversorgung Bad Rodach GmbH' },
    { id: 246, value: 'Gasversorgung Biedenkopf GmbH' },
    { id: 247, value: 'Gasversorgung Dessau GmbH' },
    { id: 248, value: 'Gasversorgung Dingolfing GmbH & Co. KG' },
    { id: 249, value: 'Gasversorgung Ebermannstadt GmbH' },
    { id: 250, value: 'Gasversorgung Eisenhüttenstadt GmbH' },
    { id: 251, value: 'Gasversorgung Frankenwald GmbH' },
    { id: 252, value: 'Gasversorgung Garbsen GmbH' },
    { id: 253, value: 'Gasversorgung Görlitz GmbH' },
    { id: 254, value: 'Gasversorgung Grafschaft Hoya GmbH' },
    { id: 255, value: 'Gasversorgung Malsch-Durmersheim GmbH' },
    { id: 256, value: 'Gasversorgung Miltenberg- Bürgstadt GmbH' },
    { id: 257, value: 'Gasversorgung Pfaffenhofen a.d. Ilm GmbH & Co. KG' },
    { id: 258, value: 'Gasversorgung Pforzheim Land GmbH' },
    { id: 259, value: 'Gasversorgung Torgelow GmbH' },
    { id: 260, value: 'Gasversorgung Vorpommern Netz GmbH' },
    { id: 261, value: 'Gasversorgung Wismar Land GmbH' },
    { id: 262, value: 'Gasversorgung Wunsiedel GmbH' },
    { id: 263, value: 'Gasversorgung Zehdenick GmbH' },
    { id: 264, value: 'Gaswerk Bad Sooden-Allendorf GmbH' },
    { id: 265, value: 'Gaswerk Illingen Zweckverband' },
    {
      id: 266,
      value: 'Gebr. Heinzelmann Stromhandels- und Vertriebs- GmbH & Co. KG'
    },
    { id: 267, value: 'Gebrüder Eirich GmbH & Co. KG' },
    {
      id: 268,
      value: 'Gebrüder Miller, Elektrizitätsversorgung GmbH & Co. KG'
    },
    { id: 269, value: 'GELSENWASSER Energienetze GmbH' },
    { id: 270, value: 'Gemeinde Glattbach' },
    { id: 271, value: 'Gemeinde Hemhofen' },
    { id: 272, value: 'Gemeinde Heroldsbach - Stromversorgung -' },
    { id: 273, value: 'Gemeinde-Elektrizitäts- und Wasserwerk Burtenbach' },
    { id: 274, value: 'Gemeindewerk Krickenbach c/o Pfalzwerke Netz AG' },
    { id: 275, value: 'Gemeindewerk Stelzenberg c/o Pfalzwerke Netz AG' },
    { id: 276, value: 'Gemeindewerke Baiersbronn' },
    { id: 277, value: 'Gemeindewerke Bayerisch Gmain' },
    { id: 278, value: 'Gemeindewerke Bovenden GmbH & Co. KG' },
    { id: 279, value: 'Gemeindewerke Budenheim' },
    { id: 280, value: 'Gemeindewerke Cadolzburg' },
    { id: 281, value: 'Gemeindewerke Dudenhofen' },
    { id: 282, value: 'Gemeindewerke Ebersdorf' },
    { id: 283, value: 'Gemeindewerke Enkenbach-Alsenborn - Elektrizitätswerk' },
    { id: 284, value: 'Gemeindewerke Frammersbach' },
    { id: 285, value: 'Gemeindewerke Gangkofen' },
    { id: 286, value: 'Gemeindewerke Garmisch-Partenkirchen, KU' },
    { id: 287, value: 'Gemeindewerke Georgensgmünd' },
    { id: 288, value: 'Gemeindewerke Grefrath GmbH' },
    { id: 289, value: 'Gemeindewerke Großkrotzenburg GmbH' },
    { id: 290, value: 'Gemeindewerke Gundelfingen GmbH' },
    { id: 291, value: 'Gemeindewerke Halstenbek' },
    { id: 292, value: 'Gemeindewerke Hardt Eigenbetrieb' },
    { id: 293, value: 'Gemeindewerke Haßloch GmbH' },
    { id: 294, value: 'Gemeindewerke Heikendorf GmbH' },
    { id: 295, value: 'Gemeindewerke Herxheim' },
    { id: 296, value: 'Gemeindewerke Hohenwestedt GmbH' },
    { id: 297, value: 'Gemeindewerke Holzkirchen GmbH' },
    { id: 298, value: 'Gemeindewerke Hördt' },
    {
      id: 299,
      value: 'Gemeindewerke Hütschenhausen c/o SW Ramstein-Miesenbach GmbH'
    },
    { id: 300, value: 'Gemeindewerke Kahl Versorgungsgesellschaft mbH' },
    { id: 301, value: 'Gemeindewerke Kiefersfelden' },
    { id: 302, value: 'Gemeindewerke Kirkel GmbH' },
    { id: 303, value: 'Gemeindewerke Krauchenwies - Stromversorgung -' },
    { id: 304, value: 'Gemeindewerke Leck-Netz GmbH' },
    { id: 305, value: 'Gemeindewerke Markt Lichtenau' },
    {
      id: 306,
      value: 'Gemeindewerke Münchweiler a.d.Rodalb Anstalt des öffentlichen Rechts'
    },
    { id: 307, value: 'Gemeindewerke Neuendettelsau' },
    { id: 308, value: 'Gemeindewerke Nüdlingen' },
    { id: 309, value: 'Gemeindewerke Nümbrecht GmbH' },
    { id: 310, value: 'Gemeindewerke Oberaudorf' },
    { id: 311, value: 'Gemeindewerke Partenstein' },
    { id: 312, value: 'Gemeindewerke Peiner Land GmbH & Co. KG' },
    { id: 313, value: 'Kommunalunternehmen Gemeindewerke Peißenberg' },
    { id: 314, value: 'Gemeindewerke Pleinfeld' },
    { id: 315, value: 'Gemeindewerke Rückersdorf' },
    { id: 316, value: 'Gemeindewerke Rülzheim' },
    { id: 317, value: 'Gemeindewerke Schönkirchen GmbH' },
    { id: 318, value: 'Gemeindewerke Schutterwald (GWS)' },
    { id: 319, value: 'Gemeindewerke Schwarzenbruck GmbH (GWS)' },
    { id: 320, value: 'Gemeindewerke Sinzheim' },
    {
      id: 321,
      value:
        'Kommunalunternehmen Gemeindewerke Stammbach Anstalt des öffentlichen Rechts des Marktes Stammbach'
    },
    { id: 322, value: 'Gemeindewerke Steinhagen GmbH' },
    { id: 323, value: 'Gemeindewerke Steißlingen' },
    { id: 324, value: 'Gemeindewerke Stockelsdorf GmbH' },
    { id: 325, value: 'Gemeindewerke Trappenkamp' },
    { id: 326, value: 'Gemeindewerke Wadgassen GmbH' },
    { id: 327, value: 'Gemeindewerke Waging a. See' },
    { id: 328, value: 'Gemeindewerke Waldfischbach-Burgalben' },
    {
      id: 329,
      value: 'Gemeindewerke Weidenthal c/o Stadtwerke Kaiserslautern'
    },
    { id: 330, value: 'Gemeindewerke Wendelstein KU' },
    { id: 331, value: 'Gemeindewerke Wendelstein Gasversorgung GmbH' },
    { id: 332, value: 'Gemeindewerke Wickede (Ruhr) GmbH' },
    { id: 333, value: 'Gemeindewerke Wildeck' },
    { id: 334, value: 'Gemeindewerke Wilhermsdorf' },
    { id: 335, value: 'Gemeindliche Werke Hengersberg' },
    { id: 336, value: 'gemeinsames Kommunalunternehmen oberes Egertal' },
    { id: 337, value: 'GEO Gesellschaft für Energieversorgung Ostalb mbH' },
    { id: 338, value: 'GeraNetz GmbH' },
    { id: 339, value: 'GETEC net alpha GmbH & Co. KG' },
    { id: 340, value: 'GETEC net beta GmbH & Co. KG' },
    { id: 341, value: 'GETEC net delta GmbH & Co. KG' },
    { id: 342, value: 'GETEC net epsilon GmbH & Co. KG' },
    { id: 343, value: 'GETEC net eta GmbH & Co. KG' },
    { id: 344, value: 'GETEC net gamma GmbH & Co. KG' },
    { id: 345, value: 'GETEC net theta GmbH & Co. KG' },
    { id: 346, value: 'GETEC net zeta GmbH & Co. KG' },
    { id: 347, value: 'Getreidemühle Zwiefalten eG' },
    { id: 348, value: 'GEW Wilhelmshaven GmbH' },
    {
      id: 349,
      value:
        'Gewerbepark Nürnberg-Feucht Versorgungs- u. Abwasserentsorgungsgesellschaft mit beschränkter Haftung'
    },
    {
      id: 350,
      value: 'GGEW, Gruppen-Gas- und Elektrizitätswerk Bergstraße AG'
    },
    { id: 351, value: 'Greizer Energienetze GmbH' },
    { id: 352, value: 'GRTgaz Deutschland GmbH' },
    {
      id: 353,
      value: 'GSW Gemeinschaftsstadtwerke GmbH Kamen, Bönen, Bergkamen'
    },
    { id: 354, value: 'GVH Gasversorgung Haar GmbH' },
    { id: 355, value: 'GVI - Gasversorgung Ismaning GmbH' },
    { id: 356, value: 'GVL-Gasversorgung Langenau GmbH' },
    { id: 357, value: 'GWB-Netz GmbH' },
    { id: 358, value: 'GWBS Netzgesellschaft mbH' },
    { id: 359, value: 'GWS Stadtwerke Hameln GmbH' },
    { id: 360, value: 'Halberstadtwerke GmbH' },
    { id: 361, value: 'Gasnetz Hamburg GmbH' },
    { id: 362, value: 'Hanau Netz GmbH' },
    { id: 363, value: 'HanseGas GmbH' },
    { id: 364, value: 'Harz Energie Netz GmbH' },
    { id: 365, value: 'Havelstrom Zehdenick GmbH' },
    { id: 366, value: 'Heilbronner Versorgungs GmbH' },
    { id: 367, value: 'Hellenstein-Energie-Logistik GmbH' },
    { id: 368, value: 'Hermann Geuder e.K.' },
    { id: 369, value: 'Hertener Stadtwerke GmbH' },
    { id: 370, value: 'Herzo Werke GmbH' },
    { id: 371, value: 'Stadtwerke Hof Energie+Wasser GmbH' },
    { id: 372, value: 'HEWA GmbH' },
    { id: 373, value: 'HKW Blumenthal GmbH' },
    { id: 374, value: 'IGS Netze GmbH' },
    { id: 375, value: 'Industriepark Werk Bobingen GmbH & Co. KG' },
    { id: 376, value: 'inetz GmbH' },
    { id: 377, value: 'infra fürth gmbh' },
    { id: 378, value: 'InfraLeuna GmbH' },
    { id: 379, value: 'InfraServ GmbH & Co. Gendorf KG' },
    { id: 380, value: 'InfraServ Gendorf Netze GmbH' },
    { id: 381, value: 'Infraserv GmbH & Co. Höchst KG' },
    { id: 382, value: 'YNCORIS GmbH & Co. KG' },
    { id: 383, value: 'InfraServ GmbH & Co. Wiesbaden KG' },
    { id: 384, value: 'Infrastrukturbetrieb der Stadt Arneburg' },
    { id: 385, value: 'Regionetz GmbH' },
    { id: 386, value: 'INNergie GmbH' },
    { id: 387, value: 'jordgasTransport GmbH' },
    { id: 388, value: 'Karlsruher Institut für Technologie' },
    { id: 389, value: 'KEW Karwendel Energie und Wasser GmbH' },
    { id: 390, value: 'KBG Kraftstrom- Bezugsgenossenschaft Homberg eG' },
    { id: 391, value: 'Keep - Kommunale Eisenberger Energiepartner GmbH' },
    { id: 392, value: 'KEW Kommunale Energie- und Wasserversorgung AG' },
    { id: 393, value: 'KMW Gastransport GmbH' },
    { id: 394, value: 'KommEnergie GmbH' },
    { id: 395, value: 'Kommunale Energienetze Inn-Salzach GmbH & Co. KG' },
    { id: 396, value: 'Kommunale Energieversorgung GmbH Eisenhüttenstadt' },
    { id: 397, value: 'TWL Netze GmbH' },
    { id: 398, value: 'Kommunalunternehmen Stadtwerke Klingenberg a.M. (AöR)' },
    { id: 399, value: 'Kommunalunternehmen Stadtwerke Weiden i. d. OPf. AöR' },
    { id: 400, value: 'Kraftwerk Farchant A. Poettinger & Co. KG' },
    { id: 401, value: 'Kraftwerk Köhlgartenwiese GmbH' },
    { id: 402, value: 'Kreiswerke Main-Kinzig GmbH' },
    { id: 403, value: 'KWH Netz GmbH' },
    { id: 404, value: 'Leitungspartner GmbH' },
    { id: 405, value: 'LEW Verteilnetz GmbH' },
    { id: 406, value: 'Licht- und Kraftwerke Helmbrechts GmbH' },
    { id: 407, value: 'Licht- und Kraftwerke Sonneberg GmbH' },
    { id: 408, value: 'Licht-, Kraft- und Wasserwerke Kitzingen GmbH' },
    { id: 409, value: 'LSW Netz GmbH & Co. KG' },
    { id: 410, value: 'Lubmin-Brandov Gastransport GmbH' },
    { id: 411, value: 'Mainfranken Netze GmbH' },
    { id: 412, value: 'MAINGAU Energie GmbH' },
    { id: 413, value: 'Main-Kinzig Netzdienste GmbH' },
    { id: 414, value: 'Mainnetz GmbH' },
    { id: 415, value: 'Mainsite GmbH & Co. KG' },
    { id: 416, value: 'Maintal-Werke-GmbH-Stadtwerke der Stadt Maintal' },
    { id: 417, value: 'Maintal-Werke-GmbH - Stadtwerke der Stadt Maintal' },
    { id: 418, value: 'Markt Egloffstein' },
    { id: 419, value: 'Markt Obernzell Elektrizitäts- versorgungsunternehmen' },
    { id: 420, value: 'Markt Stockstadt - Gemeindewerke -' },
    { id: 421, value: 'Markt Thüngen - Stromversorgung' },
    { id: 422, value: 'Markt Zellingen -Versorgungsbetriebe-' },
    { id: 423, value: 'N-ERGIE Netz GmbH' },
    { id: 424, value: 'medl GmbH' },
    { id: 425, value: 'MEGA Monheimer Elektrizitäts- und Gasversorgung GmbH' },
    { id: 426, value: 'Meißener Stadtwerke GmbH' },
    { id: 427, value: 'Mindener Stadtwerke GmbH' },
    { id: 428, value: 'Mitteldeutsche Netzgesellschaft Gas HD mbH' },
    { id: 429, value: 'Mitteldeutsche Netzgesellschaft Gas mbH' },
    { id: 430, value: 'Mitteldeutsche Netzgesellschaft Strom mbH' },
    { id: 431, value: 'Müller - Mühle GmbH & Co. KG' },
    { id: 432, value: 'Stadtnetze Münster GmbH' },
    {
      id: 433,
      value: 'MVE eurokom Gesellschaft für Energie- und Kommunikationsleistungen mbH'
    },
    { id: 434, value: 'NBB Netzgesellschaft Berlin-Brandenburg mbH & Co. KG' },
    { id: 435, value: 'MVV Netze GmbH' },
    { id: 436, value: 'Netz & Energie Betriebsgesellschaft mbH' },
    { id: 437, value: 'Netz Leipzig GmbH' },
    { id: 438, value: 'TraveNetz GmbH' },
    { id: 439, value: 'Netzbetrieb Hirschberg GmbH & Co. KG' },
    { id: 440, value: 'NETZE Bad Langensalza GmbH' },
    { id: 441, value: 'Netze BW GmbH' },
    { id: 442, value: 'Netze Duisburg GmbH' },
    { id: 443, value: 'Netze Magdeburg GmbH' },
    { id: 444, value: 'Überlandwerk Mittelbaden GmbH & Co. KG' },
    { id: 445, value: 'Netze-Gesellschaft Südwest mbH' },
    { id: 446, value: 'Netzgesellschaft Ahlen mbH' },
    { id: 447, value: 'Netzgesellschaft Bitterfeld-Wolfen mbH' },
    { id: 448, value: 'Netzgesellschaft Düsseldorf mbH' },
    { id: 449, value: 'Netzgesellschaft Eisenberg mbH' },
    { id: 450, value: 'Netzgesellschaft Forst (Lausitz) mbH & Co. KG' },
    { id: 451, value: 'Netzgesellschaft Frankfurt (Oder) mbH' },
    { id: 452, value: 'Netzgesellschaft Gütersloh mbH' },
    { id: 453, value: 'Netzgesellschaft Köthen mbH' },
    { id: 454, value: 'Netzgesellschaft Lübbecke mbH' },
    { id: 455, value: 'Netzgesellschaft Ostwürttemberg DonauRies GmbH' },
    { id: 456, value: 'Netzgesellschaft Potsdam GmbH' },
    { id: 457, value: 'Netzgesellschaft Schwerin mbH (NGS)' },
    { id: 458, value: 'Netzwerke Merzig GmbH' },
    { id: 459, value: 'Netzwerke Saarlouis GmbH' },
    { id: 460, value: 'Netzwerke Wadern GmbH' },
    { id: 461, value: 'Neubrandenburger Stadtwerke GmbH' },
    { id: 462, value: 'NEW Netz GmbH' },
    { id: 463, value: 'NGN Netzgesellschaft Niederrhein mbH' },
    { id: 464, value: 'NHF Netzgesellschaft Heilbronn-Franken mbH' },
    { id: 465, value: 'Niedersachsen Ports GmbH & Co. KG' },
    { id: 466, value: 'Nordhausen Netz GmbH' },
    { id: 467, value: 'Nowega GmbH' },
    { id: 468, value: 'NRM Netzdienste Rhein-Main GmbH' },
    { id: 469, value: 'nvb Nordhorner Versorgungsbetriebe GmbH' },
    { id: 470, value: 'NWS Netzwerke Saarwellingen GmbH' },
    { id: 471, value: 'Oberhausener Netzgesellschaft mbH' },
    { id: 472, value: 'Oberhessengas Netz GmbH' },
    { id: 473, value: 'Obermaier und Gerg Grundstücksverwaltung KG' },
    { id: 474, value: 'Ohra Energie GmbH' },
    { id: 475, value: 'ONTRAS Gastransport GmbH' },
    { id: 476, value: 'OPAL Gastransport GmbH & Co. KG' },
    { id: 477, value: 'Open Grid Europe GmbH' },
    { id: 478, value: 'Osterholzer Stadtwerke GmbH & Co. KG' },
    { id: 479, value: 'OsthessenNetz GmbH' },
    { id: 480, value: 'Outokumpu Nirosta GmbH' },
    { id: 481, value: 'ovag Netz GmbH' },
    { id: 482, value: 'OQ Services GmbH' },
    { id: 483, value: 'Pfalzgas GmbH' },
    { id: 484, value: 'Pfalzwerke Netz AG' },
    { id: 485, value: 'Pharmaserv GmbH' },
    {
      id: 486,
      value: 'Philipp Maier jun. Berneck, Inhaber Wilhelm Kempf Erben'
    },
    { id: 487, value: 'PVU Energienetze GmbH' },
    { id: 488, value: 'Raiffeisenbank Greding-Thalmässing eG' },
    { id: 489, value: 'REDINET Burgenland GmbH' },
    { id: 490, value: 'Regensburg Netz GmbH' },
    { id: 491, value: 'Regionalnetze Linzgau GmbH' },
    { id: 492, value: 'Regionalwerk Bodensee Netze GmbH & Co. KG' },
    { id: 493, value: 'Remstalwerk Netzgesellschaft GmbH' },
    {
      id: 494,
      value: 'REWAG Regensburger Energie- u. Wasserversorgung AG & Co. KG'
    },
    { id: 495, value: 'Rheinhessische Energie- und Wasserversorgungs-GmbH' },
    { id: 496, value: 'Rheinische NETZGesellschaft mbH' },
    { id: 497, value: 'Rhein-Sieg Netz GmbH' },
    { id: 498, value: 'RhönEnergie Osthessen GmbH' },
    { id: 499, value: 'Rothmoser GmbH & Co. KG' },
    { id: 500, value: 'Saalfelder Energienetze GmbH' },
    { id: 501, value: 'Schleswiger Stadtwerke GmbH' },
    { id: 502, value: 'Schleswig-Holstein Netz AG' },
    { id: 503, value: 'schwaben netz gmbh' },
    { id: 504, value: 'SEW Stromversorgungs GmbH' },
    { id: 505, value: 'Siegener Versorgungsbetriebe GmbH' },
    { id: 506, value: 'Solvay Chemicals GmbH' },
    { id: 507, value: 'Sömmerdaer Energieversorgung GmbH' },
    { id: 508, value: 'SSW Netz GmbH' },
    { id: 509, value: 'Stadt Burgbernheim - Stadtwerke' },
    { id: 510, value: 'Stadtwerke Hollfeld' },
    { id: 511, value: 'Stadtwerke Langenzenn' },
    { id: 512, value: 'Stadt- und Überlandwerke GmbH Lübben' },
    { id: 513, value: 'Stadt- und Überlandwerke GmbH Luckau-Lübbenau' },
    { id: 514, value: 'Städtische Betriebswerke Luckenwalde GmbH' },
    { id: 515, value: 'Städtische Werke Borna Netz GmbH' },
    { id: 516, value: 'Städtische Werke Magdeburg GmbH & Co. KG' },
    { id: 517, value: 'Städtische Werke Netz+Service GmbH' },
    { id: 518, value: 'Städtische Werke Spremberg (Lausitz) GmbH' },
    { id: 519, value: 'Stadtwerke Baiersdorf KU' },
    { id: 520, value: 'Stadtwerke Barmstedt' },
    { id: 521, value: 'Stadtnetze Neustadt a. Rbge. GmbH & Co. KG' },
    { id: 522, value: 'Stadtwerk am See GmbH & Co. KG' },
    { id: 523, value: 'Stadtwerk Haßfurt GmbH' },
    { id: 524, value: 'Stadtwerk Külsheim GmbH' },
    { id: 525, value: 'Stadtwerk Tauberfranken GmbH' },
    { id: 526, value: 'Stadtwerk Verl GmbH' },
    {
      id: 527,
      value: 'Stadtwerke - Altm. Gas-, Wasseru.Elektrizitätswerke GmbH Stendal'
    },
    { id: 528, value: 'Stadtwerke - Erdgas Plauen GmbH' },
    { id: 529, value: 'Stadtwerke Aalen GmbH' },
    { id: 530, value: 'Stadtwerke Achim AG' },
    { id: 531, value: 'Stadtwerke Ahaus GmbH' },
    { id: 532, value: 'Stadtwerke Ahrensburg GmbH' },
    { id: 533, value: 'Stadtwerke Altdorf GmbH' },
    { id: 534, value: 'Stadtwerke Altensteig' },
    { id: 535, value: 'Stadtwerke Amberg Versorgungs GmbH' },
    { id: 536, value: 'Stadtwerke Andernach Energie GmbH' },
    { id: 537, value: 'Stadtwerke Annaberg-Buchholz Energie AG' },
    { id: 538, value: 'Stadtwerke Annweiler am Trifels' },
    { id: 539, value: 'Stadtwerke Ansbach GmbH' },
    { id: 540, value: 'Stadtwerke Arnstadt Netz GmbH & Co. KG' },
    { id: 541, value: 'Stadtwerke Aue - Bad Schlema GmbH' },
    { id: 542, value: 'Stadtwerke Backnang GmbH' },
    { id: 543, value: 'Stadtwerke Bad Aibling' },
    { id: 544, value: 'Stadtwerke Bad Belzig GmbH' },
    { id: 545, value: 'Stadtwerke Bad Bergzabern GmbH' },
    { id: 546, value: 'Stadtwerke Bad Bramstedt Netz GmbH' },
    { id: 547, value: 'Stadtwerke Bad Brückenau GmbH' },
    { id: 548, value: 'Stadtwerke Bad Dürkheim GmbH' },
    { id: 549, value: 'Stadtwerke Bad Friedrichshall' },
    { id: 550, value: 'Stadtwerke Bad Harzburg GmbH' },
    { id: 551, value: 'Stadtwerke Bad Herrenalb GmbH' },
    { id: 552, value: 'Stadtwerke Bad Hersfeld GmbH' },
    { id: 553, value: 'Stadtwerke Bad Homburg v.d. Höhe' },
    { id: 554, value: 'Stadtwerke Bad Kissingen GmbH' },
    { id: 555, value: 'Stadtwerke Bad Nauheim GmbH' },
    { id: 556, value: 'Stadtwerke Bad Neustadt a. d. Saale' },
    { id: 557, value: 'Stadtwerke Bad Pyrmont GmbH' },
    { id: 558, value: 'Stadtwerke Bad Reichenhall KU' },
    { id: 559, value: 'Stadtwerke Bad Rodach' },
    {
      id: 560,
      value: 'Stadtwerke Bad Sachsa Gesellschaft mit beschränkter Haftung'
    },
    { id: 561, value: 'Stadtwerke Bad Säckingen GmbH' },
    { id: 562, value: 'Stadtwerke Bad Salzuflen GmbH' },
    { id: 563, value: 'Stadtwerke Bad Saulgau' },
    { id: 564, value: 'Stadtwerke Bad Sooden-Allendorf' },
    { id: 565, value: 'Stadtwerke Bad Tölz GmbH' },
    { id: 566, value: 'Stadtwerke Bad Urach' },
    { id: 567, value: 'Stadtwerke Bad Vilbel GmbH' },
    { id: 568, value: 'Stadtwerke Bad Wildbad GmbH & Co. KG' },
    { id: 569, value: 'Stadtwerke Bad Windsheim' },
    { id: 570, value: 'Stadtwerke Bad Wörishofen' },
    { id: 571, value: 'Stadtwerke Baden-Baden' },
    { id: 572, value: 'Stadtwerke Balingen' },
    {
      id: 573,
      value: 'Stadtwerke Bamberg Energie- und Wasserversorgungs GmbH'
    },
    { id: 574, value: 'Stadtwerke Bayreuth Energie und Wasser GmbH' },
    { id: 575, value: 'Stadtwerke Bebra GmbH' },
    { id: 576, value: 'Stadtwerke Bergen GmbH' },
    { id: 577, value: 'Stadtwerke Bernau GmbH' },
    { id: 578, value: 'Stadtwerke Bernburg GmbH' },
    { id: 579, value: 'Stadtwerke Bexbach GmbH' },
    { id: 580, value: 'Stadtwerke Bietigheim-Bissingen GmbH' },
    { id: 581, value: 'Stadtwerke Blankenburg GmbH' },
    { id: 582, value: 'Stadtwerke Bliestal GmbH' },
    { id: 583, value: 'Stadtwerke Bochum Netz GmbH' },
    { id: 584, value: 'Stadtwerke Bogen GmbH' },
    { id: 585, value: 'Stadtwerke Böhmetal GmbH' },
    { id: 586, value: 'Stadtwerke Bönnigheim' },
    { id: 587, value: 'Stadtwerke Borken/Westf. GmbH' },
    { id: 588, value: 'Stadtwerke Bramsche GmbH' },
    { id: 589, value: 'Stadtwerke Bredstedt - Netz GmbH' },
    { id: 590, value: 'Stadtwerke Bretten GmbH' },
    { id: 591, value: 'Stadtwerke Brilon Energie GmbH' },
    { id: 592, value: 'Stadtwerke Brühl GmbH' },
    { id: 593, value: 'Stadtwerke Brunsbüttel GmbH' },
    { id: 594, value: 'Stadtwerke Buchen GmbH & Co KG' },
    { id: 595, value: 'Stadtwerke Buchholz in der Nordheide GmbH' },
    { id: 596, value: 'Stadtwerke Büdingen' },
    { id: 597, value: 'Stadtwerke Bühl GmbH' },
    { id: 598, value: 'Stadtwerke Burg Energienetze GmbH' },
    { id: 599, value: 'Stadtwerke Burgdorf Netz GmbH' },
    { id: 600, value: 'Stadtwerke Burscheid GmbH' },
    { id: 601, value: 'Stadtwerke Buxtehude GmbH' },
    { id: 602, value: 'Stadtwerke Cham GmbH' },
    { id: 603, value: 'Stadtwerke Clausthal-Zellerfeld GmbH' },
    { id: 604, value: 'Stadtwerke Coesfeld GmbH' },
    { id: 605, value: 'Stadtwerke Crailsheim GmbH' },
    { id: 606, value: 'Stadtwerke Dachau Eigenbetr. d. Stadt Dachau' },
    { id: 607, value: 'Stadtwerke Deggendorf GmbH' },
    { id: 608, value: 'Stadtwerke Deidesheim GmbH' },
    { id: 609, value: 'Stadtwerke Delitzsch GmbH' },
    { id: 610, value: 'Stadtwerke Delmenhorst GmbH' },
    { id: 611, value: 'Stadtwerke Detmold GmbH' },
    { id: 612, value: 'Stadtwerke Dettelbach' },
    { id: 613, value: 'Stadtwerke Diez GmbH' },
    { id: 614, value: 'Stadtwerke Dillingen/Saar Netzgesellschaft mbH' },
    { id: 615, value: 'Stadtwerke Dingolfing GmbH' },
    { id: 616, value: 'Stadtwerke Dinkelsbühl' },
    { id: 617, value: 'Stadtwerke Ditzingen GmbH & Co.KG' },
    { id: 618, value: 'Stadtwerke Döbeln GmbH' },
    { id: 619, value: 'Stadtwerke Dorfen GmbH' },
    { id: 620, value: 'Stadtwerke Dreieich GmbH' },
    { id: 621, value: 'Stadtwerke Dülmen GmbH' },
    { id: 622, value: 'Stadtwerke Eberbach GmbH' },
    { id: 623, value: 'Stadtwerke Ebermannstadt Versorgungsbetriebe GmbH' },
    { id: 624, value: 'Stadtwerke Eckernförde GmbH' },
    { id: 625, value: 'Stadtwerke Eichstätt Versorgungs-GmbH' },
    { id: 626, value: 'Stadtwerke Eilenburg GmbH' },
    { id: 627, value: 'Stadtwerke Einbeck GmbH' },
    { id: 628, value: 'Stadtwerke Elbtal GmbH' },
    { id: 629, value: 'Stadtwerke Ellwangen GmbH' },
    { id: 630, value: 'Stadtwerke Elm-Lappwald GmbH' },
    { id: 631, value: 'Stadtwerke Elmshorn' },
    { id: 632, value: 'Stadtwerke Emden GmbH' },
    { id: 633, value: 'Stadtwerke Emmendingen GmbH' },
    { id: 634, value: 'Stadtwerke Emmerich GmbH' },
    { id: 635, value: 'Stadtwerke Emsdetten GmbH' },
    { id: 636, value: 'Stadtwerke Jena Netze GmbH' },
    { id: 637, value: 'Stadtwerke Engen GmbH' },
    { id: 638, value: 'Stadtwerke Erkrath GmbH' },
    { id: 639, value: 'Stadtwerke Eschwege GmbH' },
    { id: 640, value: 'Stadtwerke Essen AG' },
    { id: 641, value: 'Stadtwerke Esslingen am Neckar GmbH & Co. KG' },
    { id: 642, value: 'Stadtwerke Ostmünsterland GmbH & Co. KG' },
    { id: 643, value: 'Stadtwerke Eutin GmbH' },
    { id: 644, value: 'Stadtwerke EVB Huntetal GmbH' },
    { id: 645, value: 'Stadtwerke Fellbach GmbH' },
    { id: 646, value: 'Stadtwerke Feuchtwangen' },
    { id: 647, value: 'Stadtwerke Finsterwalde GmbH' },
    { id: 648, value: 'Stadtwerke Flensburg GmbH' },
    { id: 649, value: 'Stadtwerke Forchheim GmbH' },
    { id: 650, value: 'Stadtwerke Frankenthal GmbH' },
    { id: 651, value: 'Stadtwerke Freudenstadt GmbH & Co. KG' },
    { id: 652, value: 'Stadtwerke Friedberg' },
    { id: 653, value: 'Stadtwerke Fröndenberg Wickede GmbH' },
    { id: 654, value: 'Stadtwerke Fürstenfeldbruck GmbH' },
    { id: 655, value: 'Stadtwerke Furth im Wald GmbH & Co. KG' },
    { id: 656, value: 'Stadtwerke Gaggenau' },
    { id: 657, value: 'Stadtwerke Geesthacht GmbH' },
    { id: 658, value: 'Stadtwerke Geldern Netz GmbH' },
    { id: 659, value: 'Stadtwerke Gengenbach- Versorgungsbetriebe' },
    { id: 660, value: 'Stadtwerke Georgsmarienhütte Netz GmbH' },
    { id: 661, value: 'Stadtwerke Germersheim GmbH' },
    { id: 662, value: 'Stadtwerke Gescher GmbH' },
    { id: 663, value: 'Stadtwerke Giengen GmbH' },
    { id: 664, value: 'Stadtwerke Glauchau Dienstleistungsgesellschaft mbH' },
    { id: 665, value: 'Stadtwerke Glückstadt GmbH' },
    { id: 666, value: 'Stadtwerke GmbH Bad Kreuznach' },
    { id: 667, value: 'Stadtwerke Goch GmbH' },
    { id: 668, value: 'Stadtwerke Görlitz AG' },
    { id: 669, value: 'Stadtwerke Gotha Netz GmbH' },
    { id: 670, value: 'Stadtwerke Göttingen AG' },
    { id: 671, value: 'STADTWERKE GREVEN GMBH' },
    { id: 672, value: 'Stadtwerke Grevesmühlen GmbH' },
    { id: 673, value: 'Stadtwerke Gronau GmbH' },
    { id: 674, value: 'Stadtwerke Groß-Gerau Versorgungs GmbH' },
    { id: 675, value: 'Stadtwerke Grünstadt GmbH' },
    { id: 676, value: 'Stadtwerke Gunzenhausen GmbH' },
    { id: 677, value: 'Stadtwerke Güstrow GmbH' },
    { id: 678, value: 'Stadtwerke Hagenow GmbH' },
    { id: 679, value: 'Stadtwerke Haiger' },
    { id: 680, value: 'Stadtwerke Haldensleben GmbH' },
    { id: 681, value: 'Stadtwerke Haltern am See GmbH' },
    { id: 682, value: 'Stadtwerke Hammelburg GmbH' },
    { id: 683, value: 'Stadtwerke Harsewinkel GmbH' },
    { id: 684, value: 'Stadtwerke Haslach i.K.' },
    { id: 685, value: 'Stadtwerke Hattingen GmbH' },
    { id: 686, value: 'Stadtwerke Havelberg GmbH' },
    { id: 687, value: 'Stadtwerke Hechingen' },
    { id: 688, value: 'Stadtwerke Heide GmbH' },
    { id: 689, value: 'Stadtwerke Heidelberg Netze GmbH' },
    { id: 690, value: 'Stadtwerke Heidenheim regio GmbH' },
    { id: 691, value: 'Stadtwerke Heiligenhaus GmbH' },
    { id: 692, value: 'Stadtwerke Heilsbronn' },
    { id: 693, value: 'Stadtwerke Hemau' },
    { id: 694, value: 'Stadtwerke Hemer GmbH' },
    { id: 695, value: 'Stadtwerke Herborn GmbH' },
    { id: 696, value: 'Stadtwerke Herford GmbH' },
    { id: 697, value: 'Stadtwerke Herne AG' },
    { id: 698, value: 'Stadtwerke Herrenberg' },
    { id: 699, value: 'Stadtwerke Hettstedt GmbH' },
    { id: 700, value: 'Stadtwerke Hilden GmbH' },
    { id: 701, value: 'Stadtwerke Hockenheim' },
    { id: 702, value: 'Stadtwerke Holzminden GmbH' },
    { id: 703, value: 'Stadtwerke Homburg GmbH' },
    { id: 704, value: 'Stadtwerke Hünfeld GmbH' },
    { id: 705, value: 'Stadtwerke Husum Netz GmbH' },
    { id: 706, value: 'Stadtwerke Ilmenau GmbH' },
    { id: 707, value: 'Stadtwerke Ingolstadt Netze GmbH' },
    { id: 708, value: 'Stadtwerke Iserlohn GmbH' },
    { id: 709, value: 'Stadtwerke Itzehoe GmbH' },
    { id: 710, value: 'Stadtwerke Jülich GmbH' },
    { id: 711, value: 'Stadtwerke Kaltenkirchen GmbH' },
    { id: 712, value: 'Stadtwerke Karlsruhe Netzservice GmbH' },
    { id: 713, value: 'STADTWERKE KELHEIM GmbH & Co KG' },
    { id: 714, value: 'Stadtwerke Kempen GmbH' },
    { id: 715, value: 'Stadtwerke Kleve GmbH' },
    { id: 716, value: 'Stadtwerke Königslutter GmbH' },
    { id: 717, value: 'Stadtwerke Konstanz GmbH' },
    { id: 718, value: 'Stadtwerke Kulmbach' },
    { id: 719, value: 'Stadtwerke Kusel GmbH' },
    { id: 720, value: 'Stadtwerke Lage GmbH' },
    { id: 721, value: 'Stadtwerke Lambrecht (Pfalz) GmbH' },
    { id: 722, value: 'Stadtwerke Landau a.d.Isar' },
    { id: 723, value: 'Stadtwerke Landsberg KU' },
    { id: 724, value: 'Stadtwerke Landshut' },
    { id: 725, value: 'Stadtwerke Landstuhl' },
    { id: 726, value: 'Stadtwerke Langen GmbH' },
    { id: 727, value: 'Stadtwerke Langenfeld GmbH' },
    { id: 728, value: 'Stadtwerke Lauffen a. N. GmbH' },
    { id: 729, value: 'Stadtwerke Lauterbach GmbH' },
    { id: 730, value: 'Stadtwerke Lehrte GmbH' },
    { id: 731, value: 'Stadtwerke Leine-Solling GmbH' },
    { id: 732, value: 'Stadtwerke Lemgo GmbH' },
    { id: 733, value: 'Stadtwerke Lichtenfels' },
    { id: 734, value: 'Stadtwerke Lindau (B) GmbH & Co. KG' },
    { id: 735, value: 'Stadtwerke Lindenberg GmbH' },
    { id: 736, value: 'Stadtwerke Lingen GmbH' },
    { id: 737, value: 'Stadtwerke Lippe-Weser Service GmbH & Co. KG' },
    { id: 738, value: 'Stadtwerke Lippstadt GmbH' },
    { id: 739, value: 'Stadtwerke Löbau GmbH' },
    { id: 740, value: 'Stadtwerke Lübz GmbH' },
    { id: 741, value: 'Stadtwerke Ludwigsburg - Kornwestheim GmbH' },
    { id: 742, value: 'Stadtwerke Ludwigsfelde GmbH' },
    { id: 743, value: 'Stadtwerke Ludwigslust-Grabow GmbH' },
    { id: 744, value: 'Stadtwerke Lünen GmbH' },
    { id: 745, value: 'Stadtwerke Lutherstadt Eisleben GmbH' },
    { id: 746, value: 'Stadtwerke Lutherstadt Wittenberg GmbH' },
    { id: 747, value: 'Mainzer Netze GmbH' },
    { id: 748, value: 'Stadtwerke Malchow' },
    { id: 749, value: 'Stadtwerke Marburg GmbH' },
    { id: 750, value: 'Stadtwerke Meerane GmbH' },
    { id: 751, value: 'Stadtwerke Meinerzhagen GmbH' },
    { id: 752, value: 'Stadtwerke Meiningen GmbH' },
    { id: 753, value: 'Stadtwerke Memmingen' },
    { id: 754, value: 'Stadtwerke Menden GmbH' },
    { id: 755, value: 'Stadtwerke Mengen' },
    { id: 756, value: 'Stadtwerke Merseburg GmbH' },
    { id: 757, value: 'Stadtwerke Metzingen' },
    { id: 758, value: 'Stadtwerke Mosbach GmbH' },
    { id: 759, value: 'Stadtwerke Mössingen' },
    { id: 760, value: 'Stadtwerke Mühlacker GmbH' },
    { id: 761, value: 'Stadtwerke Mühlhausen Netz GmbH' },
    { id: 762, value: 'Stadtwerke Mühlheim am Main GmbH' },
    { id: 763, value: 'Stadtwerke Münchberg' },
    { id: 764, value: 'Stadtwerke Münsingen GmbH' },
    { id: 765, value: 'Stadtwerke Munster-Bispingen GmbH' },
    { id: 766, value: 'Stadtwerke Murrhardt' },
    { id: 767, value: 'Stadtwerke Neckargemünd GmbH' },
    { id: 768, value: 'Stadtwerke Neckarsulm' },
    { id: 769, value: 'Stadtwerke Nettetal GmbH' },
    { id: 770, value: 'Stadtwerke Neuburg a. d. Donau' },
    { id: 771, value: 'Stadtwerke Neuenhaus GmbH' },
    { id: 772, value: 'Stadtwerke Neuenstadt a. K.' },
    { id: 773, value: 'Stadtwerke Neuffen AG' },
    { id: 774, value: 'Stadtwerke Neu-Isenburg GmbH' },
    { id: 775, value: 'Stadtwerke Neumarkt i. d. OPf. Energie GmbH' },
    { id: 776, value: 'Stadtwerke Neunburg vorm Wald Strom GmbH' },
    { id: 777, value: 'Stadtwerke Neuruppin GmbH' },
    { id: 778, value: 'Stadtwerke Neuss Energie und Wasser GmbH' },
    { id: 779, value: 'Stadtwerke Neustadt a. d. Donau' },
    { id: 780, value: 'Stadtwerke Neustadt a.d. Aisch GmbH' },
    { id: 781, value: 'Stadtwerke Neustadt an der Orla GmbH' },
    { id: 782, value: 'Stadtwerke Neustadt an der Weinstraße GmbH' },
    { id: 783, value: 'Stadtwerke Neustadt in Holstein' },
    { id: 784, value: 'Stadtwerke Neustrelitz GmbH' },
    { id: 785, value: 'Stadtwerke Neuwied GmbH' },
    { id: 786, value: 'Stadtwerke Nordfriesland - Netz GmbH' },
    { id: 787, value: 'Stadtwerke Nienburg/Weser GmbH' },
    { id: 788, value: 'Stadtwerke Niesky GmbH' },
    { id: 789, value: 'Stadtwerke Norderney GmbH' },
    { id: 790, value: 'Stadtwerke Norderstedt' },
    { id: 791, value: 'SWN Stadtwerke Northeim GmbH' },
    { id: 792, value: 'Stadtwerke Nortorf AöR' },
    { id: 793, value: 'Stadtwerke Nürtingen GmbH' },
    { id: 794, value: 'Stadtwerke Oberkirch GmbH' },
    { id: 795, value: 'Stadtwerke Ochtrup' },
    { id: 796, value: 'Stadtwerke Oelsnitz/V. GmbH' },
    { id: 797, value: 'Stadtwerke Oerlinghausen GmbH' },
    { id: 798, value: 'Stadtwerke Olbernhau GmbH' },
    { id: 799, value: 'Stadtwerke Oldenburg in Holstein GmbH' },
    { id: 800, value: 'Stadtwerke Oranienburg GmbH' },
    { id: 801, value: 'Stadtwerke Pappenheim GmbH' },
    { id: 802, value: 'Stadtwerke Parchim GmbH' },
    { id: 803, value: 'Stadtwerke Pasewalk GmbH' },
    { id: 804, value: 'Stadtwerke Passau GmbH' },
    { id: 805, value: 'Stadtwerke Peine GmbH' },
    { id: 806, value: 'Stadtwerke Pfarrkirchen' },
    { id: 807, value: 'Stadtwerke Pfullingen' },
    { id: 808, value: 'Stadtwerke Pinneberg GmbH' },
    { id: 809, value: 'Stadtwerke Pirmasens Versorgungs GmbH' },
    { id: 810, value: 'Stadtwerke Plattling' },
    { id: 811, value: 'Stadtwerke Plettenberg GmbH' },
    { id: 812, value: 'Stadtwerke Porta Westfalica GmbH' },
    { id: 813, value: 'Stadtwerke Premnitz GmbH' },
    { id: 814, value: 'Stadtwerke Prenzlau GmbH' },
    { id: 815, value: 'Stadtwerke Pritzwalk GmbH' },
    { id: 816, value: 'Stadtwerke Quedlinburg GmbH' },
    { id: 817, value: 'Stadtwerke Quickborn GmbH' },
    { id: 818, value: 'Stadtwerke Radevormwald GmbH' },
    { id: 819, value: 'Stadtwerke Radolfzell GmbH' },
    { id: 820, value: 'Stadtwerke Ramstein-Miesenbach GmbH' },
    { id: 821, value: 'Stadtwerke Ratingen GmbH' },
    { id: 822, value: 'Stadtwerke Rees GmbH' },
    { id: 823, value: 'Stadtwerke Reichenbach/Vogtland GmbH' },
    { id: 824, value: 'Stadtwerke Rendsburg GmbH' },
    { id: 825, value: 'Stadtwerke Rhede GmbH' },
    { id: 826, value: 'Stadtwerke Ribnitz-Damgarten GmbH' },
    { id: 827, value: 'Stadtwerke Riesa GmbH' },
    { id: 828, value: 'Stadtwerke Rinteln GmbH' },
    { id: 829, value: 'Stadtwerke Rosenheim Netze GmbH' },
    { id: 830, value: 'Stadtwerke Rostock Aktiengesellschaft' },
    { id: 831, value: 'Stadtwerke Rostock Netzgesellschaft mbH' },
    { id: 832, value: 'Stadtwerke Rotenburg (Wümme) GmbH' },
    { id: 833, value: 'Stadtwerke Roth' },
    { id: 834, value: 'Stadtwerke Röthenbach a.d. Pegnitz GmbH' },
    { id: 835, value: 'Stadtwerke Rothenburg o.d.T. GmbH' },
    { id: 836, value: 'Stadtwerke Saarbrücken Netz AG' },
    { id: 837, value: 'Stadtwerke Sangerhausen GmbH' },
    { id: 838, value: 'Stadtwerke Schaumburg-Lippe GmbH' },
    { id: 839, value: 'Stadtwerke Scheinfeld' },
    { id: 840, value: 'Stadtwerke Schifferstadt' },
    { id: 841, value: 'Stadtwerke Schkeuditz GmbH' },
    { id: 842, value: 'Stadtwerke Schlitz' },
    { id: 843, value: 'Stadtwerke Schneeberg GmbH' },
    { id: 844, value: 'Stadtwerke Schneverdingen-Neuenkirchen GmbH' },
    { id: 845, value: 'Stadtwerke Schönebeck GmbH - SWS -' },
    { id: 846, value: 'Stadtwerke Schorndorf GmbH' },
    { id: 847, value: 'Stadtwerke Schramberg GmbH & Co. KG' },
    { id: 848, value: 'Stadtwerke Schüttorf - Emsbüren GmbH' },
    { id: 849, value: 'Stadtwerke Schwabach GmbH' },
    { id: 850, value: 'Stadtwerke Schwäbisch Gmünd GmbH' },
    { id: 851, value: 'Stadtwerke Schwäbisch Hall GmbH' },
    { id: 852, value: 'Stadtwerke Schwarzenbach/Saale' },
    { id: 853, value: 'Stadtwerke Schwarzenberg GmbH' },
    { id: 854, value: 'Stadtwerke Schwedt GmbH' },
    { id: 855, value: 'Stadtwerke Schweinfurt GmbH' },
    { id: 856, value: 'Stadtwerke Schwentinental GmbH' },
    { id: 857, value: 'Stadtwerke Schwerte GmbH' },
    { id: 858, value: 'Stadtwerke Schwetzingen GmbH & Co. KG' },
    { id: 859, value: 'Stadtwerke Senftenberg GmbH' },
    { id: 860, value: 'Stadtwerke Sigmaringen GmbH' },
    { id: 861, value: 'Stadtwerke Sindelfingen GmbH' },
    { id: 862, value: 'Stadtwerke Soest GmbH' },
    { id: 863, value: 'Stadtwerke Soltau GmbH & Co. KG' },
    { id: 864, value: 'Stadtwerke Sondershausen Netz GmbH' },
    { id: 865, value: 'Stadtwerke Speyer GmbH' },
    { id: 866, value: 'Stadtwerke Springe GmbH' },
    { id: 867, value: 'Stadtwerke St. Ingbert GmbH' },
    { id: 868, value: 'Stadtwerke Stade GmbH' },
    { id: 869, value: 'Stadtwerke Stadtoldendorf GmbH' },
    { id: 870, value: 'Stadtwerke Stadtroda GmbH' },
    { id: 871, value: 'Stadtwerke Staßfurt GmbH' },
    { id: 872, value: 'Stadtwerke Stein GmbH & Co. KG' },
    { id: 873, value: 'Stadtwerke Steinfurt GmbH' },
    { id: 874, value: 'Stadtwerke Stockach GmbH' },
    { id: 875, value: 'Stadtwerke Straubing Strom und Gas GmbH' },
    { id: 876, value: 'Stadtwerke Strausberg GmbH' },
    { id: 877, value: 'Stadtwerke Suhl/Zella-Mehlis Netz GmbH' },
    { id: 878, value: 'Stadtwerke Sulzbach/Saar GmbH' },
    { id: 879, value: 'Stadtwerke Teterow GmbH' },
    { id: 880, value: 'Stadtwerke Tirschenreuth' },
    { id: 881, value: 'Stadtwerke Torgau GmbH' },
    { id: 882, value: 'Stadtwerke Tornesch - Netz GmbH' },
    { id: 883, value: 'Stadtwerke Traunstein GmbH & Co. KG' },
    { id: 884, value: 'Stadtwerke Treuchtlingen' },
    { id: 885, value: 'SWT Stadtwerke Trier Versorgungs-GmbH' },
    { id: 886, value: 'Stadtwerke Troisdorf GmbH' },
    { id: 887, value: 'Stadtwerke Trostberg Stromversorgung GmbH' },
    { id: 888, value: 'Stadtwerke Tübingen GmbH' },
    { id: 889, value: 'Stadtwerke Tuttlingen GmbH' },
    { id: 890, value: 'Stadtwerke Uelzen GmbH' },
    { id: 891, value: 'Stadtwerke Uffenheim' },
    { id: 892, value: 'Stadtwerke Ulm/Neu-Ulm Netze GmbH' },
    { id: 893, value: 'Stadtwerke Unna GmbH' },
    { id: 894, value: 'Stadtwerke Uslar GmbH' },
    { id: 895, value: 'Stadtwerke Velbert GmbH' },
    { id: 896, value: 'Stadtwerke Velten GmbH' },
    { id: 897, value: 'Stadtwerke Verden GmbH' },
    { id: 898, value: 'Stadtwerke Viernheim Netz GmbH' },
    { id: 899, value: 'Stadtwerke Villingen-Schwenningen GmbH' },
    { id: 900, value: 'Stadtwerke Vilsbiburg' },
    { id: 901, value: 'Stadtwerke Vilshofen GmbH' },
    { id: 902, value: 'Stadtwerke Vlotho GmbH' },
    { id: 903, value: 'Stadtwerke Völklingen Netz GmbH' },
    { id: 904, value: 'Stadtwerke Wachenheim' },
    { id: 905, value: 'Stadtwerke Waiblingen GmbH' },
    { id: 906, value: 'Stadtwerke Waldkirch GmbH' },
    { id: 907, value: 'Stadtwerke Waldkirchen' },
    { id: 908, value: 'Stadtwerke Waldkraiburg GmbH' },
    { id: 909, value: 'Stadtwerke Waldmünchen' },
    { id: 910, value: 'Stadtwerke Waldshut-Tiengen GmbH' },
    { id: 911, value: 'Stadtwerke Walldorf GmbH & Co. KG' },
    { id: 912, value: 'Stadtwerke Walldürn GmbH' },
    { id: 913, value: 'Stadtwerke Waren GmbH' },
    { id: 914, value: 'Stadtwerke Wasserburg a. Inn' },
    { id: 915, value: 'Stadtwerke Wedel GmbH' },
    { id: 916, value: 'Stadtwerke Weilburg GmbH' },
    { id: 917, value: 'Stadtwerke Weinheim GmbH' },
    { id: 918, value: 'Stadtwerke Weinsberg GmbH' },
    { id: 919, value: 'STADTWERKE WEISSENBURG GmbH' },
    { id: 920, value: 'Stadtwerke Weißenfels Energienetze GmbH' },
    { id: 921, value: 'Stadtwerke Weißwasser GmbH' },
    { id: 922, value: 'Stadtwerke Werdau GmbH' },
    { id: 923, value: 'Stadtwerke Werdohl GmbH' },
    { id: 924, value: 'Stadtwerke Werl GmbH' },
    { id: 925, value: 'Stadtwerke Wernigerode GmbH' },
    { id: 926, value: 'Stadtwerke Wertheim GmbH' },
    { id: 927, value: 'Stadtwerke Wesel GmbH' },
    { id: 928, value: 'Stadtwerke Wiesbaden Netz GmbH' },
    { id: 929, value: 'Stadtwerke Willich GmbH' },
    { id: 930, value: 'Stadtwerke Wilster' },
    { id: 931, value: 'Stadtwerke Windsbach' },
    { id: 932, value: 'Stadtwerke Winsen (Luhe) GmbH' },
    { id: 933, value: 'Stadtwerke Wissen GmbH' },
    { id: 934, value: 'Stadtwerke Witten GmbH' },
    { id: 935, value: 'Stadtwerke Wittenberge GmbH' },
    { id: 936, value: 'Stadtwerke Witzenhausen GmbH' },
    { id: 937, value: 'Stadtwerke Wolfenbüttel GmbH' },
    { id: 938, value: 'Regionalwerke Wolfhager Land GmbH' },
    { id: 939, value: 'Stadtwerke Wolmirstedt GmbH' },
    { id: 940, value: 'Stadtwerke Wülfrath GmbH' },
    { id: 941, value: 'Stadtwerke Wunstorf GmbH & Co. KG' },
    { id: 942, value: 'Stadtwerke Zeil a. Main' },
    { id: 943, value: 'Stadtwerke Zeven GmbH' },
    { id: 944, value: 'Stadtwerke Zirndorf GmbH' },
    { id: 945, value: 'Stadtwerke Zittau GmbH' },
    { id: 946, value: 'Stadtwerke Zweibrücken GmbH' },
    { id: 947, value: 'Stadtwerke Zwiesel' },
    { id: 948, value: 'star.Energiewerke GmbH & Co. KG' },
    { id: 949, value: 'STEAG Netz GmbH' },
    { id: 950, value: 'Strom- und Gasnetz Wismar GmbH' },
    { id: 951, value: 'Stadtwerke Versmold GmbH' },
    { id: 952, value: 'Stromkontor Netzgesellschaft mbH' },
    { id: 953, value: 'Stromkontor Rostock Port GmbH' },
    { id: 954, value: 'Stromnetz Berlin GmbH' },
    { id: 955, value: 'Stromnetz Hamburg GmbH' },
    { id: 956, value: 'Stromnetz Kulmbach GmbH & Co. KG' },
    { id: 957, value: 'Stromnetz Weiden i.d.OPf. GmbH & Co. KG' },
    { id: 958, value: 'Stromnetzgesellschaft Hechingen GmbH & Co. KG' },
    { id: 959, value: 'Stromnetzgesellschaft Herrenberg mbH & Co. KG' },
    { id: 960, value: 'Stromversorgung Angermünde GmbH' },
    { id: 961, value: 'Stromversorgung Inzell eG' },
    { id: 962, value: 'Stromversorgung Neunkirchen GmbH' },
    { id: 963, value: 'Stromversorgung Pfaffenhofen a. d. Ilm GmbH & Co. KG' },
    { id: 964, value: 'Stromversorgung Röttenbach' },
    { id: 965, value: 'Stromversorgung Schierling eG' },
    { id: 966, value: 'Stromversorgung Seebruck eG' },
    { id: 967, value: 'Stromversorgung Stadtwerke Garbsen GmbH & Co.' },
    { id: 968, value: 'Stromversorgung Sulz am Neckar GmbH' },
    { id: 969, value: 'Stromversorgung Zerbst GmbH & Co. KG' },
    { id: 970, value: 'strotög GmbH Strom für Töging' },
    { id: 971, value: 'Stuttgart Netze Betrieb GmbH' },
    {
      id: 972,
      value: 'StWB Stadtwerke Brandenburg an der Havel GmbH & Co. KG'
    },
    { id: 973, value: 'StWL Städtische Werke Lauf a.d. Pegnitz GmbH' },
    { id: 974, value: 'SÜC Energie und H²O GmbH' },
    { id: 975, value: 'SVH Stromversorgung Haar GmbH' },
    { id: 976, value: 'SVI - Stromversorgung Ismaning GmbH' },
    { id: 977, value: 'SVS-Versorgungsbetriebe GmbH' },
    { id: 978, value: 'swa Netze GmbH' },
    { id: 979, value: 'SWB Netz GmbH' },
    { id: 980, value: 'SWB Stadtwerke Biedenkopf GmbH' },
    { id: 981, value: 'SWE Netz GmbH (Ettlingen)' },
    { id: 982, value: 'SWE Netz GmbH' },
    { id: 983, value: 'SWE Netz GmbH (Erfurt)' },
    { id: 984, value: 'SWK Stadtwerke Kaiserslautern Versorgungs-AG' },
    { id: 985, value: 'SWKiel Netz GmbH' },
    { id: 986, value: 'SWL Übertragungsnetzgesellschaft mbH' },
    { id: 987, value: 'SWL-energis Netzgesellschaft mbH & Co. KG' },
    { id: 988, value: 'SWM Infrastruktur GmbH & Co. KG' },
    { id: 989, value: 'SWN Stadtwerke Neustadt GmbH' },
    { id: 990, value: 'SWO Netz GmbH' },
    { id: 991, value: 'SWP Stadtwerke Pforzheim GmbH & Co. KG' },
    { id: 992, value: 'SWR Energie GmbH & Co. KG' },
    { id: 993, value: 'SWS Netze GmbH' },
    { id: 994, value: 'SWS Netze Solingen GmbH' },
    { id: 995, value: 'SWV Regional GmbH' },
    { id: 996, value: 'SWW Wunsiedel GmbH' },
    { id: 997, value: 'Syna GmbH' },
    { id: 998, value: 'T.W.O. Technische Werke Osning GmbH' },
    { id: 999, value: 'TaunaGas Oberursel (Taunus) GmbH' },
    { id: 1000, value: 'Technische Werke Naumburg GmbH' },
    {
      id: 1001,
      value: 'Tegernseer Erdgasversorgungsgesellschaft mbH & Co. KG'
    },
    { id: 1002, value: 'TEN Thüringer Energienetze GmbH & Co. KG' },
    { id: 1003, value: 'TenneT Offshore 1. Beteiligungsgesellschaft mbH' },
    { id: 1004, value: 'TenneT Offshore 9. Beteiligungsgesellschaft mbH' },
    { id: 1005, value: 'TenneT TSO GmbH' },
    { id: 1006, value: 'terranets bw GmbH' },
    { id: 1007, value: 'Teutoburger Energie Netzwerk eG (TEN eG)' },
    { id: 1008, value: 'Thüga Energienetze GmbH' },
    { id: 1009, value: 'Thyssengas GmbH' },
    { id: 1010, value: 'thyssenkrupp Steel Europe AG' },
    { id: 1011, value: 'TransnetBW GmbH' },
    { id: 1012, value: 'TRIDELTA Energieversorgungs GmbH' },
    { id: 1013, value: 'TWB-Technische Werke Blaubeuren GmbH' },
    { id: 1014, value: 'TWL-Verteilnetz GmbH' },
    { id: 1015, value: 'TWS Netz GmbH' },
    { id: 1016, value: 'Überlandwerk Eppler GmbH' },
    { id: 1017, value: 'Überlandwerk Erding GmbH & Co. KG' },
    { id: 1018, value: 'Überlandwerk Leinetal GmbH' },
    { id: 1019, value: 'Überlandwerk Rhön GmbH' },
    { id: 1020, value: 'Überlandzentrale Wörth/I.-Altheim Netz AG' },
    { id: 1021, value: 'Unterfränkische Überlandzentrale eG' },
    { id: 1022, value: 'Veolia Industriepark Deutschland GmbH' },
    { id: 1023, value: 'Ver- und Entsorgungswerke Bad Muskau GmbH' },
    { id: 1024, value: 'Verbandsgemeindewerke Enkenbach-Alsenborn' },
    { id: 1025, value: 'Vereinigte Stadtwerke Netz GmbH' },
    { id: 1026, value: 'Vereinigte Wertach Elektrizitätswerke GmbH' },
    { id: 1027, value: 'Versorgungsbetrieb Waldbüttelbrunn GmbH' },
    { id: 1028, value: 'Versorgungsbetriebe Bordesholm GmbH' },
    { id: 1029, value: 'VersorgungsBetriebe Elbe GmbH' },
    { id: 1030, value: 'Versorgungsbetriebe Hann. Münden GmbH' },
    { id: 1031, value: 'Versorgungsbetriebe Hoyerswerda GmbH' },
    { id: 1032, value: 'Versorgungsbetriebe Kronshagen GmbH' },
    { id: 1033, value: 'Versorgungsbetriebe Röttingen' },
    { id: 1034, value: 'VersorgungsWerke Heddesheim GmbH & Co. KG' },
    { id: 1035, value: 'Verteilnetz Plauen GmbH' },
    { id: 1036, value: 'Verteilnetze Energie Weißenhorn GmbH & Co. KG' },
    { id: 1037, value: 'VHH Netz GmbH & Co. KG' },
    { id: 1038, value: 'Vorarlberger Energienetze GmbH' },
    { id: 1039, value: 'VSE Verteilnetz GmbH' },
    { id: 1040, value: 'VW KRAFTWERK Gesellschaft mit beschränkter Haftung' },
    { id: 1041, value: 'Stadtwerke Meerbusch GmbH' },
    { id: 1042, value: 'Weißachtal-Kraftwerke eG' },
    { id: 1043, value: 'WEMAG Netz GmbH' },
    { id: 1044, value: 'Wendelsteinbahn Verteilnetz GmbH' },
    { id: 1045, value: 'Werraenergie GmbH' },
    { id: 1046, value: 'wesernetz Bremen GmbH' },
    { id: 1047, value: 'wesernetz Bremerhaven GmbH' },
    { id: 1048, value: 'Westenthanner Energieversorgung GmbH' },
    { id: 1049, value: 'Westerwald-Netz GmbH' },
    { id: 1050, value: 'Westfalen Weser Netz GmbH' },
    { id: 1051, value: 'Westnetz GmbH' },
    { id: 1052, value: 'WEV Warendorfer Energieversorgung GmbH' },
    { id: 1053, value: 'WiDe Flex Bau + Service GmbH' },
    { id: 1054, value: 'Wirtschaftsbetriebe der Stadt Norden GmbH' },
    { id: 1055, value: 'Wirtschaftsbetriebe der Stadt NSHB Borkum GmbH' },
    { id: 1056, value: 'WSW Netz GmbH' },
    { id: 1057, value: 'ZVO Energie GmbH' },
    { id: 1058, value: 'Zweckverband Gasfernversorgung Baar' },
    { id: 1059, value: 'Zwickauer Energieversorgung GmbH' },
    { id: 1060, value: 'Gemeindewerke Niefern-Öschelbronn' },
    { id: 1061, value: 'Stadtwerke Heilbad Heiligenstadt GmbH' },
    { id: 1062, value: 'GASCADE Gastransport GmbH' },
    { id: 1063, value: 'NetConnect Germany GmbH & Co. KG' },
    { id: 1064, value: 'GASPOOL Balancing Services GmbH' },
    { id: 1065, value: 'Gemeindewerke Lam' },
    { id: 1066, value: 'SWL Verteilungsnetzgesellschaft mbH' },
    { id: 1067, value: 'Saerbecker Ver- und Entsorgungsnetzgesellschaft mbH' },
    { id: 1068, value: 'Infraserv Netze GmbH' },
    { id: 1069, value: 'EFG Erdgas Forchheim GmbH' },
    { id: 1070, value: 'NEL Gastransport GmbH' },
    { id: 1071, value: 'Infrasite Griesheim GmbH' },
    { id: 1072, value: 'AlzChem Netz GmbH' },
    { id: 1073, value: 'Mittelhessen Netz GmbH' },
    {
      id: 1074,
      value: 'Hafenbetriebs- und Entwicklungsgesellschaft Sassnitz mbH'
    },
    { id: 1075, value: 'DB Energie GmbH (Bahnstromnetz 16,7 Hz)' },
    { id: 1076, value: 'Stadtwerke Greifswald GmbH' },
    { id: 1077, value: 'EWE NETZ RVN GmbH' },
    { id: 1078, value: 'TenneT Offshore DolWin3 GmbH & Co. KG' },
    { id: 1079, value: 'Weiler Wärme eG' },
    { id: 1080, value: 'EGC Infrastruktur und Netz GmbH' },
    { id: 1081, value: 'Stauferwerk  GmbH & Co. KG' },
    { id: 1082, value: 'Stadtwerke Vlotho Stromnetz GmbH' },
    { id: 1083, value: 'NordNetz GmbH' },
    { id: 1084, value: 'Stromnetz24 GmbH' },
    { id: 1085, value: 'Stromnetz Pullach GmbH' },
    { id: 1086, value: 'Propan Rheingas Beteiligungsgesellschaft mbH' },
    { id: 1087, value: 'Stadtwerke Dinslaken GmbH' },
    { id: 1088, value: 'NHL Netzgesellschaft Heilbronner Land GmbH & Co. KG' },
    { id: 1089, value: 'Stadtwerke Warburg GmbH' },
    { id: 1090, value: 'NETCUR GmbH' },
    { id: 1091, value: 'CPM Netz GmbH' },
    { id: 1092, value: 'OOWV' },
    { id: 1093, value: 'Mainova ServiceDienste GmbH' },
    { id: 1094, value: 'Wasserversorger Zweckverband Trollmühle' },
    { id: 1095, value: 'Stadtwerke Idar-Oberstein' },
    { id: 1096, value: 'Verbandsgemeindewerke Simmern-Rheinböllen' },
    { id: 1097, value: 'Wasserversorgung Rheinhessen-Pfalz GmbH' },
    { id: 1098, value: 'Verbandsgemeindewerke Kirner Land' },
    { id: 1099, value: 'Gemeinde Waldbrunn' },
    { id: 1100, value: 'Zweckverband Mittelhessische Wasserwerke' },
    { id: 1101, value: 'BDEW-LG Norddeutschland' },
    { id: 1102, value: 'Gemeinde Hünfelden' },
    { id: 1103, value: 'Gemeinde Lahnau' },
    { id: 1104, value: 'Stadtwerke Dillenburg' },
    { id: 1105, value: 'Gemeinde Ehringshausen' },
    { id: 1106, value: 'Stadtwerke Braunfels' },
    { id: 1107, value: 'Stadtwerke Solms' },
    { id: 1108, value: 'Stadtwerke Aßlar' },
    { id: 1109, value: 'Hamburger Energienetze GmbH' },
    { id: 1110, value: 'Verband der Energie- und Wasserwirtschaft des Saarlandes VEWSaar e.V.' },
    { id: 1111, value: 'Stadtwerke Hadamar' },
    { id: 1112, value: 'Gemeinde Freiensteinau' },
    { id: 1113, value: 'BadenovaNETZE GmbH' },
    { id: 1114, value: 'ZWAV - Zweckverband Wasser und Abwasser Vogtland' },
    { id: 1115, value: 'Stadtwerke Rehau' },
    { id: 1117, value: 'Stadtwerke Bad Camberg' },
    { id: 1118, value: 'Stadt Runkel-Betriebsführung Süwag' },
    { id: 1119, value: 'Gemeinde Beselich' },
    { id: 1120, value: 'Gemeinde Brechen' },
    { id: 1121, value: 'Stadtwerke Idstein' },
    { id: 1122, value: 'Gemeinde Elbtal' },
    { id: 1123, value: 'Gemeinde Elz' },
    { id: 1124, value: 'Gemeinde Löhnberg' },
    { id: 1125, value: 'Gemeinde Mengerskirchen' },
    { id: 1126, value: 'Gemeinde Merenberg' },
    { id: 1127, value: 'Gemeinde Selters (Taunus)' },
    { id: 1128, value: 'Gemeinde Dornburg' },
    { id: 1129, value: 'Gemeinde Villmar' },
    { id: 1130, value: 'Gemeinde Weilmünster' },
    { id: 1131, value: 'Gemeinde Weinbach' },
    { id: 1132, value: 'Verbandsgemeinde Diez' },
    { id: 1133, value: 'Verbandsgemeinde Aar-Einrich' },
    { id: 1134, value: 'Verbandsgemeinde Montabaur' },
    { id: 1135, value: 'Verbandsgemeinde Rennerod' },
    { id: 1136, value: 'Wasserbeschaffungsverband Usingen' },
    { id: 1137, value: 'Verbandsgemeinde Bad Ems – Nassau' },
    { id: 1138, value: 'Verbandsgemeinde Westerburg' },
    { id: 1139, value: 'Verbandsgemeinde Wallmerod' },
    { id: 1140, value: 'Trink- und Abwasserverband Eisenach - Erbstromtal' },
    { id: 1141, value: 'Wasserverband Peine' },
    { id: 1142, value: 'Wasserversorgung Sarstedt GmbH' },
    { id: 1116, value: 'Sonstige' }
  ];
}
